import React from "react";
import { StarIcon } from "../../components/icons"; // Ensure StarIcon is imported
import { getEmojiByName } from "../../utils/emojiUtils";
import { quantifyNumEnding } from "../../utils/formatNumber";

const RatingMetric = ({ starRating, ratingCount, skit }) => (
  <span className="metric">
    {/* Top row: icon and voting emoji */}
    <span className="top-line">
      <span className="icon-container">
        <StarIcon height="16px" width="16px" fillColor="#e2b645" />
      </span>
      <span className="voting">
        /{getEmojiByName("voting")}
      </span>
    </span>
    {/* Bottom row: rating values */}
    <span className="rating-values">
      <span className="metric-value">{starRating}</span>
      <span className="slash">/</span>
      <span className="metric-value">
        {quantifyNumEnding(ratingCount)}
      </span>
    </span>
  </span>
);

export default RatingMetric;
